import { render, staticRenderFns } from "./propriedadesFeixe.vue?vue&type=template&id=06db05a7&"
import script from "./propriedadesFeixe.vue?vue&type=script&lang=js&"
export * from "./propriedadesFeixe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports